import React from "react";
import { EditableHours } from "@activecollab/components";
import PropTypes from "prop-types";
import { stopwatchEditValidator } from "~/utils/utils";

const NonTickingElapsedTime = ({ hoursNotRunning, minutesNotRunning, onClick, onSave, onCancel }) => {
  return (
    <EditableHours
      className="tw-shrink-0"
      onClick={onClick}
      value={`${hoursNotRunning}:${minutesNotRunning}`}
      onCancel={onCancel}
      onSave={onSave}
      validation={stopwatchEditValidator}
      variant="Body 2"
      weight="bold"
      data-testid="editable-hours"
      ticking={false}
    />
  );
};

NonTickingElapsedTime.propTypes = {
  hoursNotRunning: PropTypes.string,
  minutesNotRunning: PropTypes.string,
  onClick: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
};

NonTickingElapsedTime.defaultProps = {
  onClick: () => null,
};

export default NonTickingElapsedTime;
